import { cn } from '@dreamstack/util/src/cn'
import React from 'react'

export const Css_Text_32_48_tw =
  'text-px-20 leading-px-30 ml:text-px-24 ml:leading-px-36'
export const Css_Text_24_36_tw = 'text-px-24 leading-px-36'
export const Css_Text_20_30_tw = 'text-px-20 leading-px-30'
export const Css_SpeechBubbleText_tw =
  'text-px-20 leading-px-30 md:text-px-32 md:leading-px-48'
export const Css_Text_16_24_tw = 'text-px-16 leading-px-24'
export const Css_Text_13_18_tw = 'text-px-13 leading-px-18'
export const Css_Text_48_60_tw = 'text-px-48 leading-px-60'
export const Css_Text_40_50_tw = 'text-px-40 leading-px-50'
export const Css_H1Hero_tw =
  'text-px-40 leading-px-50 md:text-px-56 md:leading-px-70 ml:text-px-72 ml:leading-px-80 font-semibold'
export const Css_HeadingH1_tw =
  'text-px-28 leading-px-42 md:text-px-40 md:leading-px-50 ml:text-px-56 ml:leading-px-70 font-semibold text-left'
export const Css_HeadingH2_tw =
  'text-px-24 leading-px-36 md:text-px-28 md:leading-px-42 ml:text-px-40 ml:leading-px-50 font-semibold text-left'
export const Css_HeadingH3_tw =
  'text-px-20 leading-px-30 md:text-px-24 md:leading-px-36 ml:text-px-28 ml:leading-px-42 font-semibold text-left'
export const Css_PropertyHeadingH3_tw =
  'text-px-20 leading-px-30 md:text-px-28 md:leading-px-42 font-semibold text-left'
export const Css_PropertyPriceText_tw =
  'text-px-24 leading-px-36 md:text-px-28 md:leading-px-42 font-semibold text-left'
export const Css_PropertyRoomAndSqmText_tw =
  'text-px-16 leading-px-24 md:text-px-28 md:leading-px-42 font-semibold text-left'
export const Css_PropertySmallText_tw =
  'text-px-13 leading-px-18 md:text-px-16 md:leading-px-24 text-left'
export const Css_HeadingH4_tw =
  'text-px-16 leading-px-24 md:text-px-20 md:leading-px-30 ml:text-px-20 ml:leading-px-30 font-semibold'
export const Css_BodyText_tw =
  'text-px-16 leading-px-24 ml:text-px-20 ml:leading-px-30 text-left'
export const Css_SmallText_tw =
  'text-px-13 leading-px-18 ml:text-px-16 ml:leading-px-24 text-left'
export const Css_ImageHeadingPropProject_tw =
  'text-px-40 leading-px-50 ml:text-px-72 ml:leading-px-80 font-semibold text-left'
export const Css_BarChartText_tw =
  'text-px-16 leading-px-18 ml:text-px-20 ml:leading-px-42'
export const Css_BarChartLabel_tw =
  'text-px-16 leading-px-18 ml:text-px-20 ml:leading-px-42'
export const Css_Text_20_30_To_16_24_tw =
  'text-px-16 leading-px-24 ml:text-px-20 ml:leading-px-30'
export const Css_Text_28_36_To_16_24_tw =
  'text-px-16 leading-px-24 ml:text-px-28 ml:leading-px-36'
export const Css_Text_16_24_To_13_18_5_tw =
  'text-px-13 leading-px-18 ml:text-px-16 ml:leading-px-24'
export const Css_Text_32_44_To_16_24_tw =
  'text-px-16 leading-px-24 ml:text-px-32 ml:leading-px-44'
export const Css_Custom_Block_Map_Font_H1_tw =
  'text-px-28 leading-px-42 md:text-px-48 md:leading-px-60 ml:text-px-72 ml:leading-px-80 font-semibold'

// Legacy styled component className constants replaced by *_tw raw strings above.
// Functional component wrappers mirroring previous exports (retain names & semantics).

type TextProps = React.HTMLAttributes<HTMLElement> & {
  as?: keyof React.JSX.IntrinsicElements
}

function createTextComponent(
  defaultTag: keyof React.JSX.IntrinsicElements,
  base: string
): React.ComponentType<TextProps> {
  const Comp = React.forwardRef<HTMLElement, TextProps>(
    ({ as, className, ...rest }, ref) => {
      const Tag = (as || defaultTag) as any
      return <Tag ref={ref} className={cn(base, className)} {...rest} />
    }
  )
  Comp.displayName = `Text_${defaultTag}_${base.split(' ')[0]}`
  return Comp as React.ComponentType<TextProps>
}

// Simple direct wrappers (p)
export const Text_48_60 = createTextComponent('p', Css_Text_48_60_tw)
export const Text_40_50 = createTextComponent('p', Css_Text_40_50_tw)
export const Text_32_48 = createTextComponent('p', Css_Text_32_48_tw)
export const Text_24_36 = createTextComponent('p', Css_Text_24_36_tw)
export const Text_20_30 = createTextComponent('p', Css_Text_20_30_tw)
export const SpeechBubbleText = createTextComponent(
  'p',
  Css_SpeechBubbleText_tw
)
export const Text_16_24 = createTextComponent('p', Css_Text_16_24_tw)
export const Text_13_18 = createTextComponent('p', Css_Text_13_18_tw)
export const PropertyPriceText = createTextComponent(
  'p',
  Css_PropertyPriceText_tw
)
export const PropertyRoomAndSqmText = createTextComponent(
  'p',
  Css_PropertyRoomAndSqmText_tw
)
export const PropertySmallText = createTextComponent(
  'p',
  Css_PropertySmallText_tw
)
export const BodyText = createTextComponent('p', Css_BodyText_tw)
export const FooterHeading = createTextComponent(
  'p',
  cn(Css_Text_20_30_tw, 'font-semibold')
)

// Headings
export const HeadingH1 = createTextComponent('h1', Css_HeadingH1_tw)
export const HeadingH2 = createTextComponent('h2', Css_HeadingH2_tw)
export const HeadingH3 = createTextComponent('h3', Css_HeadingH3_tw)
export const HeadingH4 = createTextComponent('h4', Css_HeadingH4_tw)
export const PropertyHeadingH3 = createTextComponent(
  'h3',
  Css_PropertyHeadingH3_tw
)
export const H1Hero = createTextComponent('h1', Css_H1Hero_tw)
export const ImageHeadingPropProject = createTextComponent(
  'h1',
  Css_ImageHeadingPropProject_tw
)
export const Custom_Block_Map_Font_H1 = createTextComponent(
  'h1',
  Css_Custom_Block_Map_Font_H1_tw
)

// Span / small text
export const MoreFlatsSmallText = createTextComponent('span', Css_SmallText_tw)
